import Api from '@/services/Api';

export default {
	loginUser(body) {
		return Api().post('/auth/login', body);
	},
	getCustomers() {
		return Api().get(`/customers`);
	},
	setLang(data) {
      return Api().post(`/user/set-lang`, data);
	}
};
